<template>
  <div class="wrapper">
    <div class="flags-row flags-mobile">
      <img
        v-for="lang in languages"
        :src="`${publicPath}flagIcons/${lang.code}.svg`"
        :alt="lang.name"
        :key="lang.code"
        class="flag-icon"
        @click="setLanguage(lang.code)"
      />
    </div>
    <BaseDropdown class="dropdown-desktop" :leftMenu="true" style="height: 100%;">
      <template v-slot:activator>
        <span class="text">
          {{ computeCurrentName }}
          <i class="fa fa-angle-down text-color"></i>
        </span>
      </template>
      
      <template v-slot:items>
        <DropdownItem
          v-for="lang in languages"
          @click="setLanguage(lang.code)"
          :key="lang.code"
          class="dropdown-item-class"
        >
          <span class="text">{{ lang.code }}</span>
        </DropdownItem>
      </template>
    </BaseDropdown>
  </div>
</template>

<script>
import DropdownItem from "./DropdownItem";
import BaseDropdown from "@/base/header/components/BaseDropdown";

export default {
  name: "Dropdown",
  components: {
    DropdownItem,
    BaseDropdown,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    current: {
      get() {
        return this.$i18n.locale;
      },
      set(val) {
        this.$store.commit("setLocale", val);
        this.$i18n.locale = val;
        this.saveLanguage(val);
      },
    },
    currentLanguage() {
      return this.languages.find((el) => el.code === this.current);
    },

    computeCurrentName: function () {
      if (this.isUndefined(this.currentLanguage)) {
        return "";
      }
      return this.currentLanguage.code;
    },
    languages() {
      const fullNameLocale = {
        en: "English",
        de: "Deutsch",
        fr: "Français",
        it: "Italiano",
      };

      return this.$i18n.availableLocales.map((loc) => {
        return {
          code: loc,
          name: fullNameLocale[loc] || loc,
        };
      });
    },
  },
  methods: {
    setLanguage(code) {
      this.current = code;
    },
    loadLanguage() {
      return localStorage.getItem("locale");
    },
    saveLanguage(code) {
      localStorage.setItem("locale", code);
    },
  },
  mounted() {
    const savedLocale = this.loadLanguage();
    const isValidLocale = this.$i18n.availableLocales.includes(savedLocale);
    const initialLocale = isValidLocale ? savedLocale : "de";
    this.setLanguage(initialLocale);
  },
};
</script>

<style lang="scss" scoped>
.text {
  text-transform: uppercase;
  font-size: 14px;
  font-family: "apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto",
    "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  color: $text-color;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  text-align: center;
}

.flags-row {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
}

.flag-icon {
  width: 32px;
  height: 32px;
  cursor: pointer;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.flags-mobile {
  display: none;
}

.dropdown-desktop {
  display: none;
}

@media (max-width: 991.98px) {
  .wrapper {
    padding: 0.75rem;
  }

  .flags-mobile {
    display: flex;
  }

  .dropdown-desktop {
    display: none;
  }
}

@media (min-width: 992px) {
  .flags-mobile {
    display: none;
  }

  .dropdown-desktop {
    display: block;
  }
}
</style>
